// WhatsApp is available to every portal user. Ignore the former build-time
// allowlist as well, so an old deployment variable cannot keep it hidden.
export function canSeeWhatsApp() {
  return true;
}
